<template>
  <d-button
    appearance="chip-color"
    class="c-chip"
    readonly="readonly"
    shape="basic"
    v-bind="$props"
  />
</template>

<script>
import DButton from 'dcode/components/DButton'

export default {
  name: 'CChip',
  components: {
    DButton
  },
  props: {
    // Values
    text: undefined,

    // Status
    selected: undefined,
    readonly: {
      type: Boolean,
      default: true
    },
    disabled: undefined,

    // Options
    palette: undefined,
    tag: undefined,

    // Icon
    icon: undefined
  }
}
</script>

<style lang="scss">
@import "~dcode/styles/font";
.c-chip {
  /* padding с лева и справа */
  --bt--ch-padding: 16px;

  &.d-button.appearance-chip-outlined,
  &.d-button.appearance-chip-color,
  &.d-button.appearance-chip {
    @include font('button');
  }
}
</style>
